import { Button, FormStatusMessage, Wrapper } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import styled from 'styled-components'

const StyledWrapper = styled(Wrapper)`
  margin-bottom: ${GTR.L};
`

const EightXEightWarning = ({
  onRetry,
}: {
  onRetry: () => void
}): React.ReactElement => (
  <StyledWrapper>
    <FormStatusMessage status="error">
      We couldn't load calls from 8x8 just now, so some calls may be missing
      below.{' '}
      <Button.Underline type="button" flush onClick={onRetry}>
        Try again
      </Button.Underline>
    </FormStatusMessage>
  </StyledWrapper>
)

export default EightXEightWarning
